export default "__VITE_ASSET__BSVyAnQf__"